import type {PartnerModel} from "~/models/partner";

export const usePartnersStore = () => {
  const { apiService } = useApi();

  const partners = useState<PartnerModel[]>('partners', () => []);
  const form = useState('partnerForm', () => {
    return {
      project: '',
      contacts: '',
    }
  });
  const formSent = ref(false);
  const formError = ref('');

  async function getPartners() {
    try {
      if (!partners.value.length) {
        const resp = await apiService.get('partnerships');
        partners.value = resp.data as PartnerModel[];
      }
    } catch (err: any) {
      console.error(err.message);
    }
  }

  async function sendPartnerForm() {
    try {
      await apiService.post('partnership/request', form.value);
      formError.value = '';
      formSent.value = true;
    } catch (err: any) {
      console.error(err.data.message);
      formError.value = err.data.message;
    } finally {
      form.value.contacts = '';
      form.value.project = '';
    }
  }

  return {
    partners,
    form,
    formSent,
    formError,
    getPartners,
    sendPartnerForm,
  }
}